import React, { useContext, useState } from 'react';
import { Navbar, Container, Row, Col, Button, Offcanvas } from 'react-bootstrap';
import { Link, Redirect } from 'react-router-dom';
import './compactacao.css';
function Compactacao() {
  const [showSidebar, setShowSidebar] = useState(false);
  const [backgroundImage, setBackgroundImage] = useState();
  const [liClicked, setLiClicked] = useState(false);


  const handleShowSidebar = (index) => {
    setShowSidebar(true);
    //setBackgroundImage(images[index]);

  }
  const handleCloseSidebar = () => {
    setShowSidebar(false);

  }
  return (
    <div className="home">
      <div className="banner" style={{ backgroundColor: '#DEDACF', width: 'auto', height: 'auto', minHeight: '1300px', minWidth: '1600px' }} >
        <Container>
          <div>

            <div className="text-center">
              {showSidebar === false ? <div className="image-wrapper">
                {/* <img src={marcageo} className="image-adjust" alt="Descrição" />
                <img src={Frase} className="image-adjust" alt="Descrição" /> */}
              </div> : null}
            </div>

          </div>
        </Container>

        <div className="sidebar-button">
          <Button variant="success" onClick={() => { handleShowSidebar(1) }} className="custom-button">
            <div className="icon-container">
              <i className="bi bi-list icon-circle"></i>
            </div>
          </Button>

        </div>
       
        {/* inicio  */}
        {/* <div className="navbarCompactacao">
  <ul className="nav nav-tabs">
    <li className="nav-item">
      <a className="nav-link active" aria-current="page" href="#">Active</a>
    </li>
    <li className="nav-item">
      <a className="nav-link" href="#">Link</a>
    </li>
    <li className="nav-item">
      <a className="nav-link" href="#">Link</a>
    </li>
    <li className="nav-item">
      <a className="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">Disabled</a>
    </li>
  </ul>
</div> */}
        <div class="navbarCompactacao">
          <div class="navbar-child">
          </div>
          
          <div class="input-field1">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field2">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input2">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field3">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field4">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field5">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input2">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field6">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field7">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field8">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input2">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field9">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field10">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field11">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input2">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field12">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="tabs">
            <div class="tab">
              <div class="label13">Label</div>
            </div>
            <div class="tab1">
              <div class="label13">Label</div>
            </div>
            <div class="tab1">
              <div class="label13">Label</div>
            </div>
            <div class="tab1">
              <div class="label13">Label</div>
            </div>
            <div class="tab1">
              <div class="label13">Label</div>
            </div>
            <div class="tab1">
              <div class="label13">Label</div>
            </div>
          </div>
          <div class="input-field13">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field14">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input2">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field15">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field16">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field17">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input2">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field18">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field19">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field20">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input2">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field21">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field22">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field23">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input2">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field24">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input2">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field25">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input2">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field26">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field27">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field28">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field29">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field30">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field31">
            <div class="input">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="toggle">
            <div class="knob">
            </div>
          </div>
          <div class="compactao-manual">Compactação Manual</div>
          <div class="toggle1">
            <div class="knob">
            </div>
          </div>
          <div class="compactao-automtica">Compactação Automática</div>
          <div class="equipamento-de-compactao">Equipamento de Compactação</div>
          <div class="input-field32">
            <div class="label">Energia de Compactação</div>
            <div class="input32">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field33">
            <div class="label">Balança Capsula</div>
            <div class="input32">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field34">
            <div class="label">Balança Cilindro</div>
            <div class="input32">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field35">
            <div class="label">Estufa</div>
            <div class="input32">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="button">
            <div class="symbol">􀊄</div>
            <div class="label41">Play</div>
          </div>
          <div class="input-field36">
            <div class="label">Número</div>
            <div class="input32">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field37">
            <div class="label">Amostra</div>
            <div class="input32">
               <input type="text" className="value" value="Value" />
            </div>
          </div>
          <div class="input-field">
            <div class="label">MOLDE DE COMPACTAÇÃO (nº)</div>
            <div class="input">
            <input type="text" className="value" value="Value" />
            </div>
          </div>
        </div>



        {/* final */}
        <div className="sidebar-Text">
          <text style={{ color: '#187A40', fontWeight: 'bold', textShadow: 'none', fontFamily: 'Open Sans, sans-serif', marginLeft: '20%' }}>Ensaio de Compactação</text>
        </div>
      </div>
      <div className="language-buttons">
        <Button variant="outline" className="rounded-circle">
          <img src="../Images/BandeiraBrasil.png" alt="Brasil" className="language-flag" />
        </Button>
        <Button variant="outline" className="rounded-circle">
          <img src="../Images/BandeiraPortugal.png" alt="Português" />
        </Button>
      </div>

      <Offcanvas show={showSidebar} onHide={handleCloseSidebar} className="first-sidebarNav">
        <div className="offcanvas-header">


          <button type="button" className="btn-close custom-btn-close" data-bs-dismiss="offcanvas" onClick={() => { handleCloseSidebar(1) }} aria-label="Close"></button>
        </div>
        <Offcanvas.Body>
          <ul>
            <li className={`${liClicked ? 'li-slide-right' : ''}`} >
              <Link to="/app/home" style={{ textDecoration: 'none' }}>
                <button className="btn btn-success mt-4 btn-block hover-effect" style={{ borderRadius: '100px', width: '70%', height: '50px', display: 'block', marginLeft: 'auto', marginRight: 'auto', fontSize: '20px' }}>Menu</button></Link>
            </li>
            {/* <li className={liClicked1 ? 'li-slide-right' : ''} onClick={() => handleLiClickSobre(3)}>
              <Button variant="link" style={{ textDecoration: 'none', color: 'white',color: liClicked1 ? '#00221A' : 'white', fontSize: '1.5em' }}>Sobre o Geo+ <span className="icon-right move-right1">
                <i className="bi bi-chevron-right"style={{textDecoration: 'none',color: liClicked1 ? '#00221A' : 'white'}}></i>
              </span></Button>
            </li> */}
            {/* <li className={liClicked2 ? 'li-slide-right' : ''} >
              <Button variant="link" style={{ textDecoration: 'none', color: 'white', fontSize: '1.5em' }}>Suporte <span className="icon-right move-right2">
                <i className="bi bi-chevron-right"></i>
              </span></Button>
            </li> */}
            {/* <li className={liClicked3 ? 'li-slide-right' : ''} onClick={() => handleLiClickGeocontrole(4)}>
              <Button variant="link" style={{ textDecoration: 'none', color: 'white',color: liClicked3 ? '#00221A' : 'white', fontSize: '1.5em' }}>Geocontrole <span className="icon-right move-right3">
                <i className="bi bi-chevron-right"style={{textDecoration: 'none',color: liClicked3 ? '#00221A' : 'white'}}></i>
              </span></Button>
            </li> */}
          </ul>
        </Offcanvas.Body>
      </Offcanvas>
    </div>

  );
}

export default Compactacao;